import React from "react";
import { Grid } from "semantic-ui-react";
import "./Dashboard.css";
import dijonImg from "../../img/mustard_spray.gif";
import ticketsImg from "../../img/tickets-ticket.gif";
import { useSelector } from 'react-redux';

// Served from public/ (copied verbatim by react-scripts, no webpack svg loader)
const waveImg = process.env.PUBLIC_URL + "/wave.svg";
// Self-hosted rather than a giphy link — an emergency button that renders as
// "this content is not available" is worse than useless.
const emergencyImg = process.env.PUBLIC_URL + "/emergency-button.svg";
const boatImg = process.env.PUBLIC_URL + "/boat-chart.svg";
// External-link cards (open the site in a new tab). Self-hosted icons.
// ?v bust: these were edge-cached as earlier static versions; bump to force the
// CDN to fetch the current animated files. Increment when an icon changes.
const rollsImg = process.env.PUBLIC_URL + "/thirtysixrolls-icon.svg?v=3";
const coachImg = process.env.PUBLIC_URL + "/coachcarl-icon.png?v=3";
const rievsImg = process.env.PUBLIC_URL + "/rievs-icon.jpg?v=3";
const flockoutImg = process.env.PUBLIC_URL + "/gettheflockout.svg?v=2";
// P vs NP explorer is a standalone static page in public/, not a React card.
const pvsnpImg = process.env.PUBLIC_URL + "/pvsnp.svg?v=1";
const campingImg = process.env.PUBLIC_URL + "/camping.svg";
const backgammonImg = process.env.PUBLIC_URL + "/backgammon.svg?v=1";
const strategyImg = process.env.PUBLIC_URL + "/strategy.svg?v=1";
const openbbImg = process.env.PUBLIC_URL + "/openbb.svg?v=1";

// Short captions shown under each tile.
const LABELS = {
  fmRadio: "Mustard Store", tickets: "Tickets", fitness: "Fitness", finance: "Finance",
  dice: "Dice", beeminder: "Beeminder", backgammon: "Backgammon", food: "Food",
  music_menu: "BBL Band", schwab: "Schwab", gipirt: "GIPIRT",
  videos: "Videos", beaches: "Dog Beaches", boat: "Boat", random: "Random",
  ledger: "Wager Ledger", cardgame: "Card Game", emergency: "Emergency",
  thirtysixrolls: "36 Rolls", coachcarl: "Coach Carl", rievs: "Rievs",
  gettheflockout: "Flock Out", pvsnp: "P vs NP",
  camping: "Camping", strategy: "Strategies", openbb: "Market Data",
};

function DashboardIcons(props) {
  const allowedCards = useSelector(state => state.permissions.allowedCards);
  const hasPermission = (cardKey) => allowedCards.includes(cardKey);

  const openCard = (cardKey) => {
    props.setActiveCards({
      ...props.activeCards,
      [cardKey]: true,
    });
  };

  const icons = [
    { id: 'fm-radio-icon', cardKey: 'fmRadio', src: dijonImg },
    { id: 'tickets-icon', cardKey: 'tickets', src: ticketsImg, imgStyle: { width: "auto", height: "110%" } },
    { id: 'fitness-icon', cardKey: 'fitness', src: "https://media.giphy.com/media/dsskR2ah7Ozlu/giphy.gif" },
    { id: 'finance-icon', cardKey: 'finance', src: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExMGczMDdtNWZ1ZDM2NnM5YWU0am5tdXQweHF6ZXd3ZHdpZjI2ZGgwcCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/wd9lhEQy2ZqQ8/giphy.gif" },
    { id: 'dice-icon', cardKey: 'dice', src: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExZDN2czBoODJmNzBubmF1ODVudTh4MXJ1N3R3Zm4xc29oYjN1dWh0MyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/gzsSUJEJQntC4lUHkq/giphy.gif" },
    { id: 'beeminder-icon', cardKey: 'beeminder', src: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExYzlhNGZ0YXZxaTM4dm1nNW9lenhkdXBjdGVobDViZ2JkN3o5dnJ2ZSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/VexAmQw9qpIQ/giphy.gif" },
    { id: 'backgammon-icon', cardKey: 'backgammon', src: backgammonImg, title: "Backgammon — money, matches & chouette" },
    { id: 'food-icon', cardKey: 'food', src: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExdTk3Znk3bXd6Zm5jdmU2enh3a3kxdHF6ZGV4OHl4YjFsOWM4aGFmYSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/uUs14eCA2SBgs/giphy.gif" },
    // `dijondreams:4533` was a docker-internal hostname — unreachable from a
    // browser. Points at bbl.band now, same as the Music dropdown in the topbar.
    { id: 'music-icon', cardKey: 'music_menu', src: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExcmJoYm13ZXExY21xbG5hYWFoMzZwaXRxZjM3djZtNmt0bm9yd2NwYyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/OTbo92zetdsha/giphy.gif", title: "BBL Band", onClick: () => { window.open('https://bbl.band', '_blank'); } },
    { id: 'schwab-icon', cardKey: 'schwab', src: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExb2pxMGI0ZnA5ZWtyMmJwYmtmOGN3Nm1xajZyZjJxbGl2Z3o3N29ndiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/JrMtbqKU9MhCMJUhCJ/giphy.gif", title: "Schwab Accounts" },
    { id: 'gipirt-icon', cardKey: 'gipirt', src: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExOXZidG01bzFrM3NueDhyYWF2bm1rc2FwZGZiZ2JzbmZ2OGRzcDZ5NCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/26AHONQ79FdWZhAI0/giphy.gif", title: "GIPIRT - Popularity & Sentiment" },
    { id: 'videos-icon', cardKey: 'videos', src: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExcW1uNWd0dHlzZGJhZDJ5aXFmNGl6Y3Rjd2ZyMmJycDd6eWMzNXhhZSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/l2JhtKtDWYNKdRpoA/giphy.gif", title: "Video Library" },
    { id: 'beaches-icon', cardKey: 'beaches', src: waveImg, title: "RI Dog Beaches" },
    { id: 'camping-icon', cardKey: 'camping', src: campingImg, title: "Camping — campgrounds + BLM land" },
    { id: 'boat-icon', cardKey: 'boat', src: boatImg, title: "Boat \u2014 chart, marinas & fuel" },
    { id: 'random-icon', cardKey: 'random', src: "https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExY21jdnhwcXh3amd4N2U0cG4yNXplMTV2aHZ3M3kwcnZ2NnJrbTQzbyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/JyW51lx5XMDgQ/giphy.gif", title: "Random" },
    { id: 'ledger-icon', cardKey: 'ledger', src: "https://media.giphy.com/media/LdOyjZ7io5Msw/giphy.gif", title: "Wager Ledger" },
    { id: 'cardgame-icon', cardKey: 'cardgame', src: "https://media.giphy.com/media/3o85xIO33l7RlmLR4I/giphy.gif", title: "Card Game" },
    { id: 'emergency-icon', cardKey: 'emergency', src: emergencyImg, title: "Emergency \u2014 wake Weston up" },
    { id: 'strategy-icon', cardKey: 'strategy', src: strategyImg, title: "Trading Strategies \u2014 author, backtest, run" },
    { id: 'openbb-icon', cardKey: 'openbb', src: openbbImg, title: "OpenBB \u2014 market & economic data" },
    { id: 'thirtysixrolls-icon', cardKey: 'thirtysixrolls', src: rollsImg, title: "36 Rolls", onClick: () => { window.open('https://thirtysixrolls.com', '_blank', 'noopener'); } },
    { id: 'coachcarl-icon', cardKey: 'coachcarl', src: coachImg, title: "Coach Carl", onClick: () => { window.open('https://coachcarl.coach', '_blank', 'noopener'); } },
    { id: 'rievs-icon', cardKey: 'rievs', src: rievsImg, title: "Rievs", onClick: () => { window.open('https://rievs.com', '_blank', 'noopener'); } },
    { id: 'gettheflockout-icon', cardKey: 'gettheflockout', src: flockoutImg, title: "Get The Flock Out", onClick: () => { window.open('https://gettheflockout.my', '_blank', 'noopener'); } },
    { id: 'pvsnp-icon', cardKey: 'pvsnp', src: pvsnpImg, title: "P vs NP Field Guide", onClick: () => { window.open(process.env.PUBLIC_URL + '/pvsnp-desktop.html', '_blank', 'noopener'); } },
  ];

  return (
    <Grid stackable style={{ padding: "20px" }}>
      <Grid.Row>
        <Grid.Column width={16} style={{ position: "relative" }}>
          {icons.map(icon => (
            hasPermission(icon.cardKey) && (
              <div key={icon.id} className="dashboard-icon-wrap">
                <div
                  id={icon.id}
                  className="dashboard-icon"
                  onClick={icon.onClick || (() => openCard(icon.cardKey))}
                >
                  <img
                    src={icon.src}
                    style={icon.imgStyle}
                    title={icon.title || LABELS[icon.cardKey]}
                    alt={icon.cardKey}
                  />
                </div>
                <div className="dashboard-icon-caption">
                  {LABELS[icon.cardKey] || icon.title || icon.cardKey}
                </div>
              </div>
            )
          ))}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default DashboardIcons;
